import { render, staticRenderFns } from "./ViewUnionid.vue?vue&type=template&id=85fd6fc0&scoped=true"
import script from "./ViewUnionid.vue?vue&type=script&lang=js"
export * from "./ViewUnionid.vue?vue&type=script&lang=js"
import style0 from "./ViewUnionid.vue?vue&type=style&index=0&id=85fd6fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fd6fc0",
  null
  
)

export default component.exports